import React, { useState } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import isEmpty from 'lodash/isEmpty'
import cn from 'classnames'
import Dehaze from '@material-ui/icons/Dehaze'
import { FormControl, MenuItem, Select } from '@material-ui/core'
import StatusIcon, {
  STATUS_TYPE_BASE,
  STATUS_TYPE_IN_PROGRESS,
  STATUS_TYPE_COMPLETE,
} from 'routes/App/Apps/DailyLogbookEvents/Questionnaire/StatusIcon'
import SidePopover from 'components/common/Popover/SidePopover'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import { TABLET_BREAKPOINT } from 'helpers/responsive'
import { LOCUS_GROUP_FIELD, LOCUS_FIELD } from 'helpers/jobs'
import messages from '../translate'

const JobTaskUnits = ({
  locusGroup,
  locus,
  needs_locus,
  needs_locus_group,
  setCurrentTaskUnits,
  locusGroupList,
  evt_tasks,
  input_items,
  locusList,
  isLoadEvtTask,
  isLoadJobInput,
  intl: { formatMessage },
}) => {
  const [isLocusOpen, setIsLocusOpen] = useState(false)
  const [isLocusGroupOpen, setIsLocusGroupOpen] = useState(false)

  const updateLocusList = locus_group => {
    const checkLocuses = needs_locus_group && needs_locus

    if (checkLocuses && locusGroup !== locus_group) {
      setCurrentTaskUnits(LOCUS_FIELD, null)
    }
  }

  const handleClosePopover = popoverName => {
    if (popoverName === LOCUS_GROUP_FIELD) {
      setIsLocusGroupOpen(false)
    } else {
      setIsLocusOpen(false)
    }
  }

  const handleChange = e => {
    const { attributes, value: mobileValue } = e.currentTarget
    const { value: desktopValue } = e.target
    const value = desktopValue || mobileValue
    const stateFieldName =
      attributes['data-field'] && attributes['data-field'].textContent
    const isLocusGroup = stateFieldName === LOCUS_GROUP_FIELD

    if (isLocusGroup) {
      updateLocusList(value)
    }

    if (ifWindowWidthLessThan(TABLET_BREAKPOINT)) {
      handleClosePopover(stateFieldName)
    }

    setCurrentTaskUnits(stateFieldName, value)
  }

  const isInputValueExist = inputs =>
    Array.isArray(inputs) &&
    inputs.some(input => input.result || input.result === false)

  const handleMobileOpen = e => {
    e.stopPropagation()
    const { id } = e.target
    const checkSelect = id === 'select-locusGroup'

    if (ifWindowWidthLessThan(TABLET_BREAKPOINT)) {
      if (checkSelect) {
        setIsLocusGroupOpen(true)
      } else {
        setIsLocusOpen(true)
      }
    } else if (checkSelect) {
      setIsLocusGroupOpen(false)
    } else {
      setIsLocusOpen(false)
    }
  }

  const getFieldStatus = (field, id) => {
    if (!evt_tasks?.length) {
      return STATUS_TYPE_BASE
    }

    const checkedField = field === 'locusGroup' ? 'locus_group' : 'locus'
    const inputsLength = input_items.filter(
      ({ input_item_type }) => input_item_type === 'input',
    ).length
    const inputsInGroupsLength = input_items
      .filter(({ input_item_type, duplicate_context }) =>
        input_item_type === 'input_group' && !isEmpty(duplicate_context)
          ? duplicate_context[checkedField] === id
          : true,
      )
      .reduce(
        (prevVal, { inputs }) => prevVal + (inputs ? inputs.length : 0),
        0,
      )

    const allFilled = evt_tasks.some(
      item =>
        item[checkedField] === id &&
        inputsLength + inputsInGroupsLength === item.evt_inputs.length &&
        isInputValueExist(item.evt_inputs, true),
    )
    const someFilled = evt_tasks.some(
      item => item[checkedField] === id && isInputValueExist(item.evt_inputs),
    )

    if (allFilled) {
      return STATUS_TYPE_COMPLETE
    }

    if (someFilled) {
      return STATUS_TYPE_IN_PROGRESS
    }

    return STATUS_TYPE_BASE
  }

  const renderLocusValue = (dataArr, condition) => {
    const data = condition && dataArr.find(item => item.id === locus)
    const locusType = getFieldStatus(LOCUS_FIELD, locus)

    if (!data) return

    return (
      <>
        <StatusIcon small type={locusType} />
        {data.name || data.containerName}
      </>
    )
  }

  const renderLocusGroupValue = () => {
    const data = locusGroupList.find(item => item.id === locusGroup)
    const locusGroupType = getFieldStatus('locus_group', locusGroup)

    if (!data) return

    return (
      <>
        <StatusIcon small type={locusGroupType} />
        {data.name}
      </>
    )
  }

  const isLocusesExist = locusList && locusList.length > 0
  const checkWidth = ifWindowWidthLessThan(TABLET_BREAKPOINT)
    ? 'mobile '
    : 'desktop'
  const selectClasses = cn('job-field-input-box', 'locus')
  const isSingleLocusGroupList = locusGroupList.length <= 1
  const isSingleLocusList = locusList.length <= 1
  const onlyLocusGroupList =
    needs_locus_group && !needs_locus && isSingleLocusGroupList
  const onlyLocusList = needs_locus && !needs_locus_group && isSingleLocusList

  return (
    <>
      {needs_locus_group &&
        (checkWidth === 'desktop' ? (
          <FormControl
            fullWidth
            className={`job-field-main-box ${checkWidth}`}
            disabled={isSingleLocusGroupList}>
            {!onlyLocusGroupList && (
              <span className="job-field-label">
                {formatMessage(messages.chooseLocusGroup)}
              </span>
            )}
            <div className="job-field-wrapper">
              {!onlyLocusGroupList && <Dehaze className="job-field-icon" />}
              <Select
                name="locusGroup"
                className={selectClasses}
                disabled={isLoadEvtTask || isLoadJobInput}
                value={locusGroup || ''}
                onChange={handleChange}
                inputProps={{
                  className: cn('job-field-input', {
                    'job-field-single-unit': onlyLocusGroupList,
                  }),
                }}
                MenuProps={{
                  classes: {
                    list: 'limited-menu-list',
                  },
                }}>
                {locusGroupList.map(item => (
                  <MenuItem
                    button
                    key={item.id}
                    component="li"
                    data-field="locusGroup"
                    value={item.id}>
                    <StatusIcon
                      small
                      type={getFieldStatus('locus_group', item.id)}
                    />
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </FormControl>
        ) : (
          <FormControl
            fullWidth
            className={`job-field-main-box ${checkWidth}`}
            disabled={isSingleLocusGroupList}>
            {!onlyLocusGroupList && (
              <span className="job-field-label">
                {formatMessage(messages.chooseLocusGroup)}
              </span>
            )}
            <div className="job-field-wrapper">
              {!onlyLocusGroupList && <Dehaze className="job-field-icon" />}
              <Select
                name="locusGroup"
                className={selectClasses}
                disabled={isLoadEvtTask || isLoadJobInput}
                value={locusGroup || ''}
                onOpen={handleMobileOpen}
                inputProps={{
                  className: cn('job-field-input', {
                    'job-field-single-unit': onlyLocusGroupList,
                  }),
                }}
                renderValue={renderLocusGroupValue}
              />
              <SidePopover
                className="extra-menu"
                open={isLocusGroupOpen}
                close={() => handleClosePopover(LOCUS_GROUP_FIELD)}
                position="bottom">
                {locusGroupList.map(item => (
                  <MenuItem
                    button
                    key={item.id}
                    component="li"
                    value={item.id}
                    name="locusGroup"
                    data-field="locusGroup"
                    onClick={handleChange}>
                    <StatusIcon
                      small
                      type={getFieldStatus('locus_group', item.id)}
                    />
                    {item.name}
                  </MenuItem>
                ))}
              </SidePopover>
            </div>
          </FormControl>
        ))}
      {needs_locus &&
        (checkWidth === 'desktop' ? (
          <FormControl
            fullWidth
            className="job-field-main-box"
            disabled={isSingleLocusList}>
            {!onlyLocusList && (
              <span className="job-field-label">
                {formatMessage(messages.chooseLocus)}
              </span>
            )}
            <div className="job-field-wrapper">
              {!onlyLocusList && <Dehaze className="job-field-icon" />}
              <Select
                name="locus-list"
                className={selectClasses}
                disabled={isLoadEvtTask || isSingleLocusList || isLoadJobInput}
                value={locus || ''}
                onChange={handleChange}
                inputProps={{
                  className: cn('job-field-input', {
                    'job-field-single-unit': onlyLocusList,
                  }),
                }}
                MenuProps={{
                  classes: {
                    list: 'limited-menu-list',
                  },
                }}>
                {isLocusesExist &&
                  locusList.map(item => (
                    <MenuItem
                      button
                      key={item.id}
                      component="li"
                      value={item.id}
                      data-field="locus">
                      <StatusIcon small type={getFieldStatus(locus, item.id)} />
                      {item.name || item.containerName}
                    </MenuItem>
                  ))}
              </Select>
            </div>
          </FormControl>
        ) : (
          <FormControl
            fullWidth
            className={`job-field-main-box ${checkWidth}`}
            disabled={isSingleLocusList}>
            {!onlyLocusList && (
              <span className="job-field-label">
                {formatMessage(messages.chooseLocus)}
              </span>
            )}
            <div className="job-field-wrapper">
              {!onlyLocusList && <Dehaze className="job-field-icon" />}
              <Select
                name="locus-list"
                open={isLocusOpen}
                disabled={isLoadEvtTask || isSingleLocusList || isLoadJobInput}
                className={`${selectClasses} ${checkWidth}`}
                value={locus || ''}
                onOpen={handleMobileOpen}
                inputProps={{
                  className: cn('job-field-input', {
                    'job-field-single-unit': onlyLocusList,
                  }),
                }}
                renderValue={() => renderLocusValue(locusList, isLocusesExist)}
              />
              <SidePopover
                className="extra-menu"
                open={isLocusOpen}
                close={() => handleClosePopover(LOCUS_FIELD)}
                position="bottom">
                {isLocusesExist &&
                  locusList.map(item => (
                    <MenuItem
                      button
                      key={item.id}
                      component="li"
                      value={item.id}
                      name="locus"
                      data-field="locus"
                      onClick={handleChange}>
                      <StatusIcon small type={getFieldStatus(locus, item.id)} />
                      {item.name || item.containerName}
                    </MenuItem>
                  ))}
              </SidePopover>
            </div>
          </FormControl>
        ))}
    </>
  )
}

export default connect(state => ({
  isLoadEvtTask: state.getIn(['myJobs', 'isLoadEvtTask']),
  isLoadJobInput: state.getIn(['myJobs', 'isLoadJobInput']),
}))(injectIntl(JobTaskUnits))
